module.exports = __webpack_public_path__ + "static/img/logo5.0a02b07.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo5.png
// module id = Sc21
// module chunks = 1